// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var Survey$ReactHooksTemplate = require("./survey.res.js");
var Loading$ReactHooksTemplate = require("../dashboard/dashboard/Loading.res.js");
var SurveyView$ReactHooksTemplate = require("./SurveyView.res.js");
var SurveyTheme$ReactHooksTemplate = require("./surveyTheme.res.js");
var CustomerInfo$ReactHooksTemplate = require("./CustomerInfo.res.js");
var Substitution$ReactHooksTemplate = require("../common/Substitution.res.js");
var SurveyLanguage$ReactHooksTemplate = require("./surveyLanguage.res.js");
var ApplicationSettings$ReactHooksTemplate = require("../general_settings/applicationSettings.res.js");
var OrganizationProfile$ReactHooksTemplate = require("../settings/organizationProfile.res.js");

function decodeSurvey(json) {
  var survey = Json_decode.field("survey", Survey$ReactHooksTemplate.fromJson, json);
  var surveyLanguages = Json_decode.field("survey", (function (param) {
          return Json_decode.field("survey_languages", (function (param) {
                        return Json_decode.list(SurveyLanguage$ReactHooksTemplate.fromJson, param);
                      }), param);
        }), json);
  var language = Belt_Option.getWithDefault(Json_decode.field("survey", (function (param) {
              return Json_decode.optional((function (param) {
                            return Json_decode.field("survey_language", SurveyLanguage$ReactHooksTemplate.fromJson, param);
                          }), param);
            }), json), SurveyLanguage$ReactHooksTemplate.default);
  var client = Json_decode.field("survey", (function (param) {
          return Json_decode.field("organization_profile", OrganizationProfile$ReactHooksTemplate.decode, param);
        }), json);
  var applicationSettings = Json_decode.field("survey", (function (param) {
          return Json_decode.field("system_settings", ApplicationSettings$ReactHooksTemplate.decoder, param);
        }), json);
  var transactionStatus = Json_decode.field("survey", (function (param) {
          return Json_decode.field("transaction_status", Json_decode.string, param);
        }), json);
  var verificationCode = Json_decode.field("survey", (function (param) {
          return Json_decode.optional((function (param) {
                        return Json_decode.field("verification_code", Json_decode.string, param);
                      }), param);
        }), json);
  return [
          survey,
          CustomerInfo$ReactHooksTemplate.fromJson(json),
          client,
          transactionStatus,
          surveyLanguages,
          language,
          applicationSettings,
          verificationCode
        ];
}

function reducer(state, action) {
  var customerInfo = action._1;
  var survey = action._0;
  return {
          survey: survey,
          customerInfo: customerInfo,
          skipSurvey: state.skipSurvey,
          theme: state.theme,
          client: action._2,
          transactionStatus: action._3,
          surveyLanguages: action._4,
          language: action._5,
          applicationSettings: action._6,
          verificationCode: action._7,
          substitutionVariables: Substitution$ReactHooksTemplate.buildSubstitutionMapWithPriority(Survey$ReactHooksTemplate.dataFields(survey), customerInfo)
        };
}

function SurveyPage(props) {
  var id = props.id;
  var emptyState_survey = Survey$ReactHooksTemplate.empty();
  var emptyState_customerInfo = CustomerInfo$ReactHooksTemplate.empty();
  var emptyState_theme = SurveyTheme$ReactHooksTemplate.empty();
  var emptyState_client = OrganizationProfile$ReactHooksTemplate.empty();
  var emptyState_applicationSettings = ApplicationSettings$ReactHooksTemplate.empty();
  var emptyState_substitutionVariables = {};
  var emptyState = {
    survey: emptyState_survey,
    customerInfo: emptyState_customerInfo,
    skipSurvey: false,
    theme: emptyState_theme,
    client: emptyState_client,
    transactionStatus: "",
    surveyLanguages: /* [] */0,
    language: SurveyLanguage$ReactHooksTemplate.default,
    applicationSettings: emptyState_applicationSettings,
    verificationCode: undefined,
    substitutionVariables: emptyState_substitutionVariables
  };
  var match = React.useReducer(reducer, emptyState);
  var dispatch = match[1];
  var state = match[0];
  var match$1 = React.useState(function (param) {
        return "Loading";
      });
  var setMode = match$1[1];
  React.useEffect((function (param) {
          Js_promise.then_((function (param) {
                  Curry._1(dispatch, {
                        TAG: "Initialize",
                        _0: param[0],
                        _1: param[1],
                        _2: param[2],
                        _3: param[3],
                        _4: param[4],
                        _5: param[5],
                        _6: param[6],
                        _7: param[7]
                      });
                  return Promise.resolve(Curry._1(setMode, (function (param) {
                                    return "Ready";
                                  })));
                }), Js_promise.then_((function (json) {
                      return Promise.resolve(decodeSurvey(json));
                    }), Http$ReactHooksTemplate.fetchPostEncodedJSON("/api/v1/survey_details", Json_encode.object_({
                            hd: [
                              "api",
                              Json_encode.object_({
                                    hd: [
                                      "token",
                                      id
                                    ],
                                    tl: /* [] */0
                                  })
                            ],
                            tl: /* [] */0
                          }))));
        }), []);
  switch (match$1[0]) {
    case "Loading" :
        return JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx(Loading$ReactHooksTemplate.make, {
                          text: "Loading Survey..."
                        }),
                    className: "h-screen w-full animated fadeIn"
                  });
    case "Ready" :
        return JsxRuntime.jsx(JsxRuntime.Fragment, {
                    children: Caml_option.some(JsxRuntime.jsx(SurveyView$ReactHooksTemplate.make, {
                              survey: state.survey,
                              client: state.client,
                              transactionStatus: state.transactionStatus,
                              surveyLanguages: state.surveyLanguages,
                              language: state.language,
                              customerInfo: state.customerInfo,
                              preview: false,
                              token: id,
                              applicationSettings: state.applicationSettings,
                              currentPage: 1,
                              verificationCode: state.verificationCode,
                              substitutionVariables: state.substitutionVariables
                            }))
                  });
    case "Saving" :
        return JsxRuntime.jsx("p", {
                    children: "Saving survey in progress..."
                  });
    
  }
}

var make = SurveyPage;

exports.decodeSurvey = decodeSurvey;
exports.reducer = reducer;
exports.make = make;
/* react Not a pure module */
